export const BLOG_ARTICLES = [
  {
    slug: "cout-dj-mariage-drome-2027",
    title: "Combien coûte un DJ mariage haut de gamme en Drôme en 2027 ?",
    meta: "Tarifs DJ mariage en Drôme en 2027 : de 800 € à 1 600 € selon la formule. Ce qui est réellement inclus, ce qui fait la différence de prix, et comment comparer les devis.",
    excerpt:
      "Entre 800 € et 1 600 €, ce qui change concrètement : durée de présence, lumière, effets scéniques, préparation. Le point complet pour comparer sereinement.",
    date: "2026-09-02",
    minutes: 4,
    img: "https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?w=1200&q=80&auto=format&fit=crop",
    sections: [
      {
        h2: "Les fourchettes réellement constatées",
        paragraphs: [
          "Pour un mariage en Drôme, une prestation DJ professionnelle se situe généralement entre 800 € et 1 600 €. Chez KLMProd, la formule Essentielle démarre à 800 €, la Médium à 1 200 € et la Prestige à 1 600 € — avec, dans les trois cas, une présence jusqu'à 4 H du matin.",
          "Méfiez-vous des tarifs très bas : ils cachent souvent une présence limitée dans le temps, du matériel d'entrée de gamme ou l'absence de préparation. À l'inverse, au-delà de 2 000 €, vérifiez ce qui justifie l'écart : musiciens live, effets pyrotechniques, ou simple effet de marché.",
        ],
      },
      {
        h2: "Ce qui fait la différence de prix",
        paragraphs: [
          "Trois postes expliquent l'essentiel de l'écart entre les formules : la lumière (mise en lumière de la salle par projecteurs LED, programmation DMX personnalisée), les effets scéniques (étincelles froides, fumée lourde pour la première danse) et les équipements annexes (sonorisation de la cérémonie, micros supplémentaires, vidéoprojecteur avec écran).",
          "Le reste — rendez-vous de préparation, playlist collaborative, coordination avec vos témoins et prestataires — devrait être inclus dans toute prestation sérieuse, quel que soit le niveau choisi.",
        ],
      },
      {
        h2: "Ce qui doit figurer dans votre devis",
        paragraphs: [
          "Un devis lisible détaille : les horaires de présence, le matériel installé, les options, le montant de l'acompte (30 % chez KLMProd, payable en ligne) et les conditions d'annulation. Si l'un de ces éléments manque, demandez-le par écrit.",
          "Notre conseil : comparez des prestations à périmètre identique. Un DJ « moins cher » qui part à 2 H du matin ou facture le déplacement en sus n'est pas nécessairement moins cher au final.",
        ],
      },
    ],
  },
  {
    slug: "5-questions-avant-de-reserver-son-dj",
    title: "5 questions à poser avant de réserver son DJ",
    meta: "Playlist collaborative, plan B matériel, coordination des surprises, horaires, contrat : les 5 questions qui distinguent un vrai professionnel d'un DJ amateur pour votre mariage.",
    excerpt:
      "Cinq questions simples qui vous éviteront 90 % des déceptions le jour J — de la playlist collaborative au contrat écrit.",
    date: "2026-09-02",
    minutes: 3,
    img: "https://images.unsplash.com/photo-1429962714451-bb934ecdc4ec?w=1200&q=80&auto=format&fit=crop",
    sections: [
      {
        h2: "1. Comment choisit-on les musiques ?",
        paragraphs: [
          "La bonne réponse ressemble à notre playlist collaborative : vous et vos invités proposez vos titres en amont, le DJ construit une programmation cohérente. Chez KLMProd, les demandes sont clôturées 48 h avant l'événement — c'est ce délai qui garantit des transitions fluides plutôt qu'une soirée en mode shuffle.",
        ],
      },
      {
        h2: "2. Que se passe-t-il en cas de panne ?",
        paragraphs: [
          "Un professionnel utilise du matériel de régie (notre régie : Pioneer DJ, sonorisation Yamaha, micros Sennheiser) et sait gérer les imprévus. Posez aussi la question des discours et surprises : chez nous, deux contacts référents — vos témoins par exemple — coordonnent tout avec nous, pour préserver l'effet de surprise.",
        ],
      },
      {
        h2: "3. Jusqu'à quelle heure êtes-vous là ?",
        paragraphs: [
          "C'est la question que peu de couples posent — et que tous regrettent à 2 H du matin. Nos trois formules incluent une présence jusqu'à 4 H du matin, sans supplément horaire. Exigez ce point par écrit.",
        ],
      },
      {
        h2: "4. Avez-vous un contrat écrit ?",
        paragraphs: [
          "Devis détaillé, contrat signé (en ligne chez KLMProd), acompte de 30 % à la signature : ces trois éléments vous protègent mutuellement. Nous recommandons en outre une assurance annulation et intempéries, surtout pour les réceptions en extérieur.",
        ],
      },
      {
        h2: "5. Qui gère le timing avec les autres prestataires ?",
        paragraphs: [
          "Ouverture de bal, pièce montée, discours : votre DJ doit se synchroniser avec le traiteur, le photographe et le lieu. Un rendez-vous de préparation et un fil conducteur écrit font toute la différence entre une soirée fluide et une suite d'à-coups.",
        ],
      },
    ],
  },
  {
    slug: "eclairages-led-reception-mariage",
    title: "Nos éclairages LED pour sublimer votre réception",
    meta: "Mise en lumière LED de la salle, programmation DMX, fumée lourde et étincelles froides : comment l'éclairage transforme une salle de réception en véritable scène de mariage.",
    excerpt:
      "Projecteurs LED sur batterie, programmation DMX personnalisée, effet nuage pour la première danse : ce que la lumière change vraiment dans une salle des fêtes.",
    date: "2026-09-02",
    minutes: 3,
    img: "https://images.unsplash.com/photo-1492684223066-81342ee5ff30?w=1200&q=80&auto=format&fit=crop",
    sections: [
      {
        h2: "La mise en lumière, l'effet le plus spectaculaire",
        paragraphs: [
          "Quelques projecteurs LED sur batterie suffisent à transformer une salle des fêtes : murs habillés de vos couleurs, poutres mises en valeur, ambiance chaude pendant le dîner puis dynamique pour la soirée. C'est inclus dès notre formule Médium.",
          "L'avantage des projecteurs sur batterie : aucun câble disgracieux au sol, une installation propre même dans les domaines et bastides où les prises sont rares.",
        ],
      },
      {
        h2: "La programmation DMX : la lumière devient scénographie",
        paragraphs: [
          "En formule Prestige, nous programmons chaque moment via un contrôleur DMX : teinte douce pour le vin d'honneur, effets synchronisés sur l'entrée des mariés, show lumineux pour l'ouverture de bal. La lumière suit le fil de votre soirée au lieu de clignoter en mode automatique.",
        ],
      },
      {
        h2: "Fumée lourde et étincelles froides : les effets signature",
        paragraphs: [
          "La machine à fumée lourde crée un tapis de nuages au sol — l'effet est saisissant sur les photos de première danse et reste sans danger ni odeur. Les étincelles froides, elles, encadrent l'ouverture de bal ou la pièce montée : non pyrotechniques, elles sont utilisables en intérieur dans la plupart des lieux (nous validons toujours avec le domaine en amont).",
          "Ces options sont disponibles en formule Prestige ou sur devis dédié. Parlez-nous de votre salle : nous vous dirons franchement ce qui y fonctionnera — et ce qui n'y apportera rien.",
        ],
      },
    ],
  },
];
